import React, { Component } from 'react'
import bsb from '../images/buoy-local-logo-empowering.png'
import { getStyles } from '../Constants/utilityFunctions'

import '../Styles/RedirectBanner.css';
class RedirectBanner extends Component {
  render() {
    const { width } = this.props
    let styles = getStyles(width)


    return (
      <>
        <div className="container">
          <img src={bsb} alt=''/>
          <h1>We've Moved!</h1>
          <p>
            Please update your bookmarks to{' '}
            <a id="new-site-link" href="https://merchants.buoylocal.com">
              https://merchants.buoylocal.com
            </a>.
          </p>
        </div>
      </>
    );
  }
}

export default RedirectBanner;
